import {create} from "zustand";
import {persist} from "zustand/middleware";

const useThemeStore = create(
  persist(
    (set, get) => ({
      mode: "light", // "light" o "dark"

      toggleTheme: () => {
        set((state) => ({
          mode: state.mode === "light" ? "dark" : "light"
        }));
      },

      setTheme: (mode) => {
        set({mode});
      },

      isDark: () => get().mode === "dark"
    }),
    {
      name: "theme-storage",
      partialize: (state) => ({mode: state.mode})
    }
  )
);

export {useThemeStore};
